import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_MEDIUM,
  GRAY_DARKER,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_6,
  FONT_WEIGHT_BOLD,
  UHUU_COLOR,
  FONT_SIZE_2,
  FONT_SIZE_7,
} from '../../styles/variables';

export const Header = styled.div`
  margin-bottom: 35px;
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
`;

export const Container = styled.div`
  ${flexPosition({ align: 'flex-start', justify: 'space-between' })}
  height: 100%;
  position: relative;
`;

export const CloseButton = styled.button`
  width: 22px;
  height: 22px;
  padding: 0;
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background-color: transparent;
  outline: none;
`;

export const CloseIcon = styled.img`
  max-width: 100%;
`;

export const LeftInfo = styled.div`
  width: 53%;
`;

export const RightInfo = styled.div`
  width: 47%;
  height: 100%;
`;

export const Content = styled.div`
  ${flexPosition({ align: 'flex-start', justify: 'flex-start' })}
  flex-direction: column;
  padding: 25px 30px 35px;
`;

export const Title = styled.h1`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_2, FONT_WEIGHT_NORMAL)}
  text-align: center;
  margin: 0;
`;

export const UhuuClient = styled(Link)`
  ${fontStyle(UHUU_COLOR, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
  &:hover, &:active, &:focus, &:visited {
    color: ${UHUU_COLOR};
    /* text-decoration: none; */
  }
`;

export const Label = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
`;

export const Desc = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
`;

export const Form = styled.form`
  width: 100%;
`;

export const CustomLabelSeparator = styled.span`
  margin-right: 8px;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_NORMAL)}
`;

export const CustomLabel = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_NORMAL)}
`;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/style.js